// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y-zA","footer":"styles_footer__2op31"};